"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.Container = exports.Label = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3;

var Label = _styledComponents["default"].label(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  position: relative;\n  margin-bottom: ", "px;\n  cursor: pointer;\n  font-size  : 14px;\n  font-weight: ", ";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  align-items: center;\n"])), _widths.widths.base, function (props) {
  return props.checked ? _widths.font.medium : _widths.font.regular;
});

exports.Label = Label;
Label.displayName = 'Label';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var Input = _styledComponents["default"].input(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n"])));

exports.Input = Input;
Input.displayName = 'Input';